import {
    IFollowPeopleData,
    IPremiumUserInvoiceData,
    IPremiumSubscriptionForm,
    IPremiumUserData,
    ISearchedOrganization,
    ISearchedOrganizationCategory,
    ISearchedOrganizationFilter,
    IDaoTreasuryInvestmentsStateData,
    IDaoTreasuryInvestmentProtocol,
    IDaoTreasuryInvestmentType,
    IDaoTreasuryInvestmentProtocolAndType,
    IDaoTreasuryIndividualOrganization,
    IDaoTokensError,
    IOrganizationTrends,
    IOrganizationAssetsTable,
    IOrganizationVoterInterests,
    IOVIYearByYear,
    IOVIVoterRanks,
    IOVIVoterEcosystemParticipation,
    IOVIBreakdownEcosystem,
    IOVIBreakdownOrg,
    IOVICompetitorDaosForOrgVoters,
    IOVICompetitorDaosForOrgTokenHolders,
    ICoalitionItem,
    IVotingToken,
    IAvgVotesAndTokenPricePerDate,
    ITreasuryComposition,
    IOrganizationHoldingToken,
    ITreasuryCompositionGraph,
    IOrganizationVoterGroups,
    IOrganizationTopVoter,
    IOrganizationActiveVoter,
    IDaoVoter,
    IDaoProposer,
    IExecutiveStats,
} from 'types/interfaces';
import { IFollowOrganizationData } from 'types/interfaces';
import { ILoggedUserData } from './auth.interfaces';
import {
    IChartItem,
    IStatsChartChanges,
    IFeedItems,
    IShareholderItems,
    IUserItems,
    IOrganizationMembers,
    IVotingCoalition,
    IAssetsTableItems,
    IFundsGraphItems,
    IProposalChartItems,
    IActivityStatsItems,
    IVotingStatsItems,
    IResearchData,
    IOrganizationInfo,
    IOrganizationTool,
    IProjectToken,
    IErrorResponse,
} from './custom.interfaces';
import { IFaqItems } from './faqs.interfaces';
import {
    IFeedOrganizationSearchedData,
    IFeedItemsData,
    IFeedActivityData,
    IFeedActivityGraph,
    IFeedGraphCounters,
} from './feed.interfaces';
import {
    IOrganizationActivityData,
    IOrganizationInfoData,
    IOrganizationSimilarDao,
    IOrganizationCurrency,
    IAssetInfo,
    IOrganizationDecision,
    IOrganizationMemberDataWithId,
    IOrganizationTopShareholder,
    IAumGraphItems,
    IOrganizationDao,
    IDiscussionItems,
    IDiscussionsFilterMember,
    IOrganizationSubstorm,
} from './organization.interfaces';
import {
    IOrganizationExtendedData,
    IOrganizationsTokensData,
    IOrganizationsEcosystem,
    IOrganizationTopTokensData,
    IOrganizationsTotalTrasuryData,
    IOrganizationsStatsInfo,
    IOrganizationsdActiveMembersGraph,
    IOrganizationCategory,
} from './organizations.interfaces';
import { IPeopleData, ITopTokensData } from './people.interfaces';
import { IEcosystemCategory, IResourceData } from './resources.interfaces';
import {
    IUserData,
    IUserVotesData,
    IUserProposalsData,
    ISimilarUserData,
    IUserTokenData,
    IUserNotificationsData,
    IUserFriendsAndEnemiesData,
    IUserLabelsInfo,
} from './user.interfaces';
import { ALERT_TYPES } from 'constants/alert';
import { IFeedProposalItems } from './feedProposal.interfaces';
import { IApiItems, IApiPlans } from './api.interfaces';
import { IUserSearchItems, IOrganizationSearchItems } from './search.interfaces';
import { ISelfListingElement } from './selfListing.interfaces';
import { IListedOrganizationData } from './selfListing.interfaces';
import { IPaypalPlan } from './plans.interfaces';
import { BRAINSTORM_ACTION_TYPE } from 'constants/discussionsElements';
import { NOTIFICATIONS_ACTIONS_TYPES } from 'constants/notificationsActions';
import { ORGANIZATIONS_PARAMS } from 'constants/organizationsSorting';
import { DAO_TOKENS_PARAMS } from 'constants/daoTokensSorting';
import {
    IOrganizationActiveDelegate,
    IOrganizationTab,
    IOrganizationTabsError,
    IOrganizationTopDelegate,
} from './organizationTabs.interfaces';
import { ORGANIZATION_VOTER_INTERESTS_FIELDS } from '../../constants/organizationTabs';

interface IOrganizationsState {
    loading: boolean;
    paginationLoading: boolean;
    daoEcosystemOverview: IOrganizationsEcosystem;
    organizationsTokensData: IOrganizationsTokensData[];
    organizationsData: IOrganizationExtendedData[];
    nextOrganizationsData: IOrganizationExtendedData[];
    organizationsTopTokens: IOrganizationTopTokensData[];
    organizationsTotalTreasury: IOrganizationsTotalTrasuryData;
    organizationsOverThresholdAum: IOrganizationsStatsInfo;
    organizationsPotentialVoters: IOrganizationsStatsInfo;
    organizationsActiveMembers: IOrganizationsStatsInfo;
    organizationsOverThresholdActiveMembers: IOrganizationsdActiveMembersGraph;
    lastUpdate: string | null;
    organizationsCount: number | null;
    enrichedOrganizationsCount: number | null;
    organizationsCategories: IOrganizationCategory[];
    currentOrganizationsListPage: number;
    isEndOfOrganizationsList: boolean;
    orderBy: ORGANIZATIONS_PARAMS;
    paginationOrderDescending: boolean;
}

interface IDaoTokensState {
    error: IDaoTokensError | undefined;
    loading: boolean;
    paginationLoading: boolean;
    daoTokens: any[];
    nextDaoTokens: any[];
    currentPage: number;
    isEndOfDaoTokensList: boolean;
    orderBy: DAO_TOKENS_PARAMS;
    paginationOrderDescending: boolean;
}

interface IReducerAction {
    type: string;
    payload: unknown;
}
export enum COALITION_NAME {
    GOVERNOR = 'governor delegate',
    SNAPSHOT_DELEGATE = 'snapshot delegate',
    SNAPSHOT_VOTER = 'snapshot voter',
}
interface IOrganizationState {
    loading: boolean;
    similarDaosLoading: boolean;
    organizationInfo: IOrganizationInfo;
    feeds: IFeedItems[];
    shareholders: IShareholderItems[];
    similarPeople: IUserItems[];
    organizationMembers: IOrganizationMembers[];
    votingCoalitions: IVotingCoalition[];
    assetsData: IAssetsTableItems[];
    fundsGraphData: IFundsGraphItems[];
    proposalsChartData: IProposalChartItems[];
    activityStats: IActivityStatsItems;
    votingStats: IVotingStatsItems;
    researchData: IResearchData;
    organizationData: IOrganizationInfoData;
    organizationSimilarDaos: IOrganizationSimilarDao[];
    organizationActivityData: IOrganizationActivityData;
    organizationCurrenciesData: IOrganizationCurrency[];
    organizationDecisionsData: IOrganizationDecision[];
    decisionsDataLoading: boolean;
    organizationMembersData: IOrganizationMemberDataWithId[];
    membersDataLoading: boolean;
    organizationCoalitionsData: ICoalitionItem[];
    coalitionType: COALITION_NAME;
    coalitionsDataLoading: boolean;
    organizationTopShareholdersByHoldings: IOrganizationTopShareholder[];
    organizationTopActiveShareholders: IOrganizationTopShareholder[];
    socialAssets: IAssetInfo[];
    daoAssets: IAssetInfo[];
    organizationDaoAssetsTable: IOrganizationAssetsTable[];
    organizationDaoAssetsTableLoading: boolean;
    organizationDaoAssetsTableError: IErrorResponse | null;
    aumGraphData: IAumGraphItems[];
    organizationDaos: IOrganizationDao[];
    activityDataLoading: boolean;
    organizationDiscussions: IDiscussionItems[];
    discussionModalOpen: boolean;
    createDiscussionLoading: boolean;
    discussionsLoading: boolean;
    userOrganizationRole: null | string;
    projectToken: IProjectToken;
    organizationTools: IOrganizationTool[];
    discussionsFilterMembers: IDiscussionsFilterMember[];
    organizationDiscussion: IDiscussionItems;
    discussionLoading: boolean;
    discussionsError: boolean;
    brainstormActionType: BRAINSTORM_ACTION_TYPE | null;
    discussionForEditingId: string | null;
    substormsList: IOrganizationSubstorm[];
    isOrganizationFollowingLoader: boolean;
    isOrganizationFollowing: boolean;
    discussionsIdsWithCommentError: string[];
    commentsIdsWithReplyError: string[];
    discussionsIdsWithVoteError: string[];
    commentsIdsWithVoteError: string[];
    discussionCreatingError: boolean;
    allowInteractionWithDiscussions: boolean;
    topShareholdersByHoldingsLoading: boolean;
    topActiveShareholdersLoading: boolean;
    aumGraphDataLoading: boolean;
    daoAssetsDataLoading: boolean;
    daoAssetsError: IErrorResponse | null;
    organizationCurrenciesDataLoading: boolean;
    organizationToolsDataLoading: boolean;
    substormsDataLoading: boolean;
    executiveStats: IExecutiveStats | null;
    executiveStatsLoading: boolean;
    executiveStatsError: IErrorResponse | null;
    executiveStatsErrorChecked: boolean;
    daoVoters: {
        data: IDaoVoter[];
        loading: boolean;
    };
    daoProposers: {
        data: IDaoProposer[];
        loading: boolean;
    };
}

interface IFeedState {
    loading: boolean;
    feedActivityData: IFeedActivityData;
    feedOrganizations: IFeedOrganizationSearchedData[];
    feedItems: IFeedItemsData[];
    hasMoreDataToLoad: boolean;
    votesGraphData: IFeedActivityGraph[];
    decisionsGraphData: IFeedActivityGraph[];
    discussionsGraphData: IFeedActivityGraph[];
    feedCounters: IFeedGraphCounters;
    feedLastUpdateDate: string | null;
    organizationsCount: number | null;
    activityDataLoading: boolean;
    statsDataLoading: boolean;
    enrichedOrganizationsCount: number | null;
}

interface IPeopleState {
    loading: boolean;
    hasMore: boolean;
    totalAumUSD: IChartItem[];
    peopleAUMbyDeciles: IChartItem[];
    totalAUMBreackdown: IChartItem[];
    topTokensByUsd: IChartItem[];
    topTokensByPeople: IChartItem[];
    totalPeopleAumChanges: IStatsChartChanges;
    peopleData: IPeopleData[];
    topPeopleTokensData: ITopTokensData[];
    lastUpdateDate: string | null;
    organizationsCount: number | null;
    enrichedOrganizationsCount: number | null;
}

interface IPeopleStatsProps {
    isMobile: boolean;
    topTokensByPeople: IChartItem[];
    peopleAUMbyDeciles: IChartItem[];
    totalPeopleAumChanges: IStatsChartChanges;
}

interface IUserState {
    loading: boolean;
    updateAvatarLoading: boolean;
    updateUserOpportunitiesLoading: boolean;
    similarPeopleByOrganizationsLoading: boolean;
    similarPeopleByTokensLoading: boolean;
    userTokenListLoading: boolean;
    userData: IUserData;
    userProposalsData: IUserProposalsData;
    userVotesData: IUserVotesData;
    similarPeopleByOrganizations: ISimilarUserData[];
    similarPeopleByTokens: ISimilarUserData[];
    userTokenListData: IUserTokenData[];
    userTotalAum: number | string | null;
    userAboutSectionOpen: boolean;
    userNotificationsData: IUserNotificationsData;
    isUserFollowing: boolean;
    isUserFollowingLoader: boolean;
    notificationsOffset: number;
    hasMoreNotifications: boolean;
    notificationsActionType: NOTIFICATIONS_ACTIONS_TYPES;
    userEnemiesData: IUserFriendsAndEnemiesData[];
    userFriendsData: IUserFriendsAndEnemiesData[];
    userEnemiesDataLoading: boolean;
    userFriendsDataLoading: boolean;
    friendsAndEnemiesError: IErrorResponse | null;
    userProposalsDataLoading: boolean;
    userVotesDataLoading: boolean;
    userLabelsData: IUserLabelsInfo | null;
}

interface IAuthState {
    status: string;
    token: string | null;
    refreshToken: string | null;
    address: string | null;
    challenge: string | null;
    error: Error | null;
    loading: boolean;
    adminToken: boolean;
    loggedUserData: ILoggedUserData;
}

interface ISearchState {
    organizationsSearchByCategoryResults: IOrganizationSearchItems[];
    peopleSearchResults: IUserSearchItems[];
    organizationsSearchResults: IOrganizationSearchItems[];
    topThreeOrganizations: IOrganizationSearchItems[];
    topThreeUsers: IUserSearchItems[];
    searchLoading: boolean;
    topUserOrganizations: IOrganizationSearchItems[];
    userOrganizationsSearchResults: IOrganizationSearchItems[];
}

interface IResourcesState {
    loading: boolean;
    resourcesData: IResourceData[];
    resourcesCategoriesData: IEcosystemCategory[];
}

interface ISocialFeaturesState {
    loading: boolean;
    followingOrganizationsData: IFollowOrganizationData[];
    followedPeopleData: IFollowPeopleData[];
    followingPeopleData: IFollowPeopleData[];
    followingAmount: number;
    followersAmount: number;
    followingPeopleAmount: number;
    followingOrganizationsAmount: number;
    followingPeopleLoading: boolean;
    followingOrganizationsLoading: boolean;
}

interface IFaqState {
    faqsLoading: boolean;
    singleFaqLoading: boolean;
    faqsList: IFaqItems[];
    singleFaqData: IFaqItems;
}

interface IAlertState {
    isAlertOpen: boolean;
    title: string;
    description?: string;
    type: ALERT_TYPES | null;
}

interface IFeedProposalState {
    loading: boolean;
    feedProposalData: IFeedProposalItems;
}

interface IApiState {
    apisList: IApiItems[];
    apiPlans: IApiPlans[];
}

interface ISelfListingState {
    selfListingModalOpen: boolean;
    selfListingChainsList: ISelfListingElement[];
    selfListingPlatformsList: ISelfListingElement[];
    listOrganizationLoading: boolean;
    selfListingDataLoaded: boolean;
    type: null | string;
    listedOrganizationData: IListedOrganizationData;
    listedOrganizationDataLoading: boolean;
    error: boolean;
}

interface IPremiumSubscriptionState {
    loading: boolean;
    form: IPremiumSubscriptionForm;
    paypalSubscription: ISubscription;
    paypalSubscriptionLoading: boolean;
    apiKey: string | null;
    subscriptionLoading: boolean;
    paypalSubscriptionError: string | null;
    premiumLoginLoading: boolean;
    premiumLoginError: string | null;
    premiumUserInvoices: IPremiumUserInvoiceData[];
    premiumUserInvoicesLoading: boolean;
    premiumAccessToken: string | null;
    premiumRefreshToken: string | null;
    premiumUserData: IPremiumUserData;
    premiumUserDataLoading: boolean;
    premiumPFToken: string | null;
    cancelSubscriptionError: string | null;
}

interface IPremiumPlansState {
    loading: boolean;
    paypalPlans: IPaypalPlan[];
    paypalPlan: IPaypalPlan;
}

interface ISubscription {
    id: string;
    create_time: string;
    status: string;
    subscriber: ISubscriber;
    plan: IPaypalPlan;
}

interface ISubscriber {
    email_address: string;
    payer_id: string;
    name: {
        given_name: string;
        surname: string;
    };
}

interface IApiKey {
    apiKey: string;
}

interface IOrganizationsSearchState {
    organizationsSearchedDataLoading: boolean;
    categoriesDataLoading: boolean;
    organizationsSearchedData: ISearchedOrganization[];
    organizationsCategoriesData: ISearchedOrganizationCategory[];
    selectedFiltersData: ISearchedOrganizationFilter[];
    offset: number;
}

interface IOrganizationTabsState {
    error: IOrganizationTabsError | undefined;
    organizationTabs: {
        data: IOrganizationTab[];
        loading: boolean;
        lastUpdate: string | null;
    };
    organizationActiveDelegates: {
        data: IOrganizationActiveDelegate[];
        loading: boolean;
        lastUpdate: string | null;
    };
    organizationTopDelegates: {
        data: IOrganizationTopDelegate[];
        loading: boolean;
        lastUpdate: string | null;
        delegatesType: 'snapshot' | 'governor' | null;
    };
    organizationActiveVoters: {
        data: IOrganizationActiveVoter[];
        loading: boolean;
        lastUpdate: string | null;
    };
    organizationTopVoters: {
        data: IOrganizationTopVoter[];
        loading: boolean;
        lastUpdate: string | null;
    };
    organizationProposalsTrends: {
        data: IOrganizationTrends[];
        loading: boolean;
        lastUpdate: string | null;
    };
    organizationSuccessfulProposalsTrends: {
        data: IOrganizationTrends[];
        loading: boolean;
        lastUpdate: string | null;
    };
    organizationVotesTrends: {
        data: IOrganizationTrends[];
        loading: boolean;
        lastUpdate: string | null;
    };
    organizationVotersTrends: {
        data: IOrganizationTrends[];
        loading: boolean;
        lastUpdate: string | null;
    };
    organizationAverageVotesPerProposalTrends: {
        data: IOrganizationTrends[];
        loading: boolean;
        lastUpdate: string | null;
    };
    [ORGANIZATION_VOTER_INTERESTS_FIELDS.YEAR_BY_YEAR]: IOrganizationVoterInterests<IOVIYearByYear>;
    [ORGANIZATION_VOTER_INTERESTS_FIELDS.VOTER_RANKS]: IOrganizationVoterInterests<IOVIVoterRanks>;
    [ORGANIZATION_VOTER_INTERESTS_FIELDS.VOTER_ECOSYSTEM_PARTICIPATION]: IOrganizationVoterInterests<IOVIVoterEcosystemParticipation>;
    [ORGANIZATION_VOTER_INTERESTS_FIELDS.BREAKDOWN_ECOSYSTEM]: IOrganizationVoterInterests<IOVIBreakdownEcosystem>;
    [ORGANIZATION_VOTER_INTERESTS_FIELDS.BREAKDOWN_ORG]: IOrganizationVoterInterests<IOVIBreakdownOrg>;
    [ORGANIZATION_VOTER_INTERESTS_FIELDS.COMPETITOR_DAOS_FOR_ORG_VOTERS]: IOrganizationVoterInterests<IOVICompetitorDaosForOrgVoters>;
    [ORGANIZATION_VOTER_INTERESTS_FIELDS.COMPETITOR_DAOS_FOR_ORG_TOKEN_HOLDERS]: IOrganizationVoterInterests<IOVICompetitorDaosForOrgTokenHolders>;
    organizationTreasuryTrends: {
        data: any[];
        loading: boolean;
        lastUpdate: Date | null;
    };
    organizationTreasuryCompositionGraph: {
        data: ITreasuryCompositionGraph | null;
        loading: boolean;
    };
    organizationVotingToken: {
        data: IVotingToken | null;
        loading: boolean;
        lastUpdate: Date | null;
    };
    organizationAvgVotesAndTokenPriceGraph: {
        data: IAvgVotesAndTokenPricePerDate[];
        loading: boolean;
        lastUpdate: Date | null;
    };
    organizationTreasuryComposition: {
        data: ITreasuryComposition[];
        loading: boolean;
    };
    organizationHoldingToken: {
        data: IOrganizationHoldingToken[];
        loading: boolean;
    };
    organizationVoterGroups: {
        data: IOrganizationVoterGroups | null;
        loading: boolean;
    };
}

type IDaoTreasuryInvestmentsState =
    | IDaoTreasuryInvestmentsStateData<IDaoTreasuryInvestmentProtocol>
    | IDaoTreasuryInvestmentsStateData<IDaoTreasuryInvestmentType>
    | IDaoTreasuryInvestmentsStateData<IDaoTreasuryInvestmentProtocolAndType>
    | IDaoTreasuryInvestmentsStateData<IDaoTreasuryIndividualOrganization>;

export type {
    ISocialFeaturesState,
    IOrganizationsState,
    IReducerAction,
    IOrganizationState,
    IDaoTokensState,
    IFeedState,
    IPeopleState,
    IUserState,
    IAuthState,
    ISearchState,
    IResourcesState,
    IFaqState,
    IAlertState,
    IFeedProposalState,
    IApiState,
    ISelfListingState,
    IPremiumSubscriptionState,
    ISubscription,
    IApiKey,
    IPeopleStatsProps,
    IPremiumPlansState,
    IOrganizationsSearchState,
    IDaoTreasuryInvestmentsState,
    IOrganizationTabsState,
};
